import { Eye } from "tabler-icons-react";

export const SkillsHeaders = [
  { id: "id", numeric: true, disablePadding: true, label: "ID" },

  //give full width to the question column
  {
    id: "skillName",
    numeric: false,
    disablePadding: true,
    label: "Skill",
  },
  {
    id: "skillDescription",
    numeric: false,
    disablePadding: true,
    label: "Description",
  },
  {
    id: "actions",
    view: <Eye />,

    numeric: false,
    label: "Actions",
  },
];
